import React, { useState } from 'react';
import { player_index } from '../constants/player_index';
import { useNavigate } from 'react-router-dom';

interface Player {
  name: string;
  team: string;
}

const SearchBox = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredPlayers, setFilteredPlayers] = useState<Player[]>([]);

  const navigate = useNavigate();

  const getURLFriendlyName = (name: string) => {
    return name.toLowerCase().replace(' ',  '_')
  }

  const handleSearch = (player: Player) => {
    setSearchTerm(player.name);
    setFilteredPlayers([]);
    navigate('/squad/' + getURLFriendlyName(player.team)+'#'+getURLFriendlyName(player.name))
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value;
    setSearchTerm(query);

    if (query.length === 0) {
      setFilteredPlayers([]);
      return;
    }

    const results = player_index.filter(player => player.name.toLowerCase().includes(query.toLowerCase()))
    .sort((a, b) => a.name.localeCompare(b.name)); ;
    setFilteredPlayers(results);

    // if (results.length === 1) {
    //   handleSearch(results[0]);
    // }
  };

  return (
    <div style={{display: 'flex', justifyContent: 'center', marginBottom: '20px'}}>
      <input
        type="text"
        value={searchTerm}
        placeholder="Search for a player..."
        onChange={handleChange}
        style={{ width: '50%', padding: '10px', fontSize: '16px', border: '1px solid #ccc', borderRadius: '5px', outline: 'none' }}
      />
      {filteredPlayers.length > 0 && (
        <ul style={{ position: 'absolute', width: '50%', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '5px',
        marginTop: '40px', listStyle: 'none', padding: '0' }}>
          {filteredPlayers.map((player, index) => (
            <li
              key={index}
              style={{ padding: '10px', cursor: 'pointer' }}
              onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f0f0f0'; }}
              onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#fff'; }}
              onClick={() => handleSearch(player)}
            >
              {player.name} - {player.team}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchBox;
